<template>
  <span class="avatar-component"
        :class="[
          `size-${size}`,
        ]"
  >
    <ym-img class="avatar-img"
            :src="avatar"
            radius="50%"
            :alt="name"
            :lazy="lazy"
    />
  </span>
</template>

<script>
  export default {
    name: 'Avatar',
    props: {
      avatar: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        default: '头像',
      },
      size: {
        type: String,
        validator(val) {
          return [
            'extra-small',
            'small',
            'normal',
            'medium',
            'large',
          ].includes(val);
        },
        default: 'normal',
      },
      lazy: {
        type: Boolean,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .avatar {
    &-component {
      flex-shrink: 0;
      display: inline-block;
      width: @avatar-size-base;
      height: @avatar-size-base;
      border: @border-base;
      border-radius: @avatar-round-radius;
      position: relative;
      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
      &.size-extra-small {
        width: @avatar-size-extra-small;
        height: @avatar-size-extra-small;
      }
      &.size-small {
        width: @avatar-size-small;
        height: @avatar-size-small;
      }
      &.size-medium {
        width: @avatar-size-medium;
        height: @avatar-size-medium;
      }
      &.size-large {
        width: @avatar-size-large;
        height: @avatar-size-large;
      }
    }

    &-img {
      width: 100%;
      height: 100%;
    }
  }
</style>
